/**
 * Created by Julio Perez on 9/20/2016.
 */
require('angular');


class NavLinksStripService{
    constructor($sce){

        let vm = this;
        vm.data= require('./sections-list.json');
        vm.contentName = vm.getContentNameByID(0);


    }

    getSectionData(){

        let vm = this;
        return vm.data;

    }

    getContentNameByID(id =0){

        let vm = this;
        vm.contentName = vm.data
            .filter(function(content){
                return content.index === id;
            })
            .map(function(content){
                return {
                    name: content.name,
                    range_short: content.range_short,
                    range_long: content.range_long,
                    id: content.id
                }
            }).shift();

        return vm.contentName;

    }


}


export default angular
    .module('navLinksStripService', [])
    .service('navLinksStripService', NavLinksStripService)
    .name;

NavLinksStripService.$inject = [];


// WEBPACK FOOTER //
// ./src/app/ui/nav-links-strip/nav-links-strip.service.js